import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Navigate, useLocation } from 'react-router-dom';
import auth from '../../firebase.init';
import useAdmin from '../../hooks/useAdmin';
import Loading from '../Shared/Loading';

const RequireAdmin = ({children}) => {
    
        const [user,loading] = useAuthState(auth);
        const [admin,adminLoading] = useAdmin(user)
        let location = useLocation();
        
        if(loading || adminLoading) {
            return <Loading></Loading>;
        }
        if (!user || !admin) {
          // Redirect them to the /login page, but save the current location they were
          // trying to go to when they were redirected. This allows us to send them
          // along to that page after they login, which is a nicer user experience
          // than dropping them off on the home page.
          return <Navigate to="/login" state={{ from: location }} replace />;
        }
        return children;
    };

export default RequireAdmin;